export default function (db) {
    db.Collection.prototype.transform = async function(transformer) {
        const result = await transformer.handle(this)
        
        // Nettoyer le transformer après usage pour éviter les fuites mémoire
        // Le transformer créé à la volée (new TierTransformer('light')) 
        // garde sinon son cache requests et #cachedColumns indéfiniment
        if (transformer.emptyCache) {
            transformer.emptyCache()
        }
        // Nullifier les propriétés internes pour permettre le GC
        if (transformer.requests) {
            transformer.requests = {}
        }
        
        return result
    }
}
